<div class="smartphones">

  <sc-master-detail [selection]="[selectedSmartphone]" [data]="smartphones" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <mat-tab-group>

      <mat-tab [label]="'base-data' | translate: ['tmc-yard.smartphones.entity.base-data', translationService.language, translationService.revision]">

        <sc-scroll-pane>
          <form class="form" #smartphoneForm="ngForm">
            <sc-padding>
              @if (workingCopyDetails) {
                <sc-flex vertical stretchContent
                  class="no-field-space">
                  <mat-form-field appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.smartphone.number.label"></sc-dictionary-label>
                    </mat-label>
                    <input [(ngModel)]="workingCopyDetails.nbr" #ctrlNumber="ngModel" name="nbr" matInput
                      [required]="true" [maxlength]="255" />
                    </mat-form-field>
                    <sc-content-spacer vertical></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.smartphone.serialnumber.label"></sc-dictionary-label>
                      </mat-label>
                      <input [(ngModel)]="workingCopyDetails.serialNbr" name="serialNbr" matInput
                        [required]="false" [maxlength]="255" />
                      </mat-form-field>
                      <sc-content-spacer vertical></sc-content-spacer>
                      <mat-form-field appearance="fill">
                        <mat-label>
                          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.currentPosition.hint"></sc-dictionary-label>
                        </mat-label>
                        <textarea [(ngModel)]="workingCopyDetails.hint" name="hint" matInput
                        [required]="false" [maxlength]="1024"></textarea>
                      </mat-form-field>
                      <sc-content-spacer vertical></sc-content-spacer>
                      <mat-checkbox [(ngModel)]="workingCopyDetails.available" name="available">
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.smartphone.available.label"></sc-dictionary-label>
                      </mat-checkbox>
                    </sc-flex>
                  }
                </sc-padding>
              </form>
            </sc-scroll-pane>
          </mat-tab>


          <mat-tab [label]="'report' | translate: ['tmc-yard.smartphones.entity.report', translationService.language, translationService.revision]">
            <app-equipment-log  [equipmentIdentifier]="equipmentIdentifier"></app-equipment-log>
          </mat-tab>
        </mat-tab-group>

        <ng-template masterDetailToolbar>
          <sc-cancel-button class="config-changed-button" (click)="cancel()"
          [disabled]="!cancelEnabled"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
        </ng-template>

      </sc-master-detail>

    </div>
